import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import SimpleTable from "../../../components/SimpleTable";
import { useNavigate } from "react-router-dom";
import { BASE_URL, postData } from "../../Utils/Baseurl";
import { Stack } from "@mui/material";
import CanAccess from "../../../components/permission/CanAccess";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";

const Meeting = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { rolePermission, currentUser } = useAuth();

  useEffect(() => {
    getEmplyoeeList();
  }, []);

  // emplyooee list
  const getEmplyoeeList = async () => {
    setIsLoading(true);
    const formdata = {
      user_id: currentUser?.id,
    };
    try {
      const response = await postData("api/getmeeting/", formdata);

      if (response?.status && Array.isArray(response.data)) {
        const data = response?.data?.map((item) => {
          const totalTasks = item?.tasks?.length || 0;
          const completedCount = item?.tasks?.filter(
            (task) => task.status === "Completed"
          ).length;

          return {
            ...item,
            taskList: totalTasks
              ? `${completedCount} / ${totalTasks}`
              : "0 / 0",
          };
        });
        setList(data);
      } else {
        setList([]);
      }
    } catch (error) {
      console.error("Error while fetching role list:", error);
      setList([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Table column data
  const userColumns = [
    { header: "TITLE", key: "meeting_title" },
    { header: "PROJECT", key: "project_name" },
    { header: "DATE", key: "meeting_date" },
    { header: "START TIME", key: "meeting_start_time" },
    { header: "END TIME", key: "meeting_end_time" },
    { header: "TASK", key: "taskList" },
    { header: "ACTION", key: "action" },
  ];
  // Table row data
  const userData = list.map((item) => ({
    id: item?.id,
    meeting_title: item?.meeting_title,
    meeting_start_time: item?.meeting_start_time,
    meeting_end_time: item?.meeting_end_time,
    meeting_date: item?.meeting_date,
    taskList: item?.taskList,
    allData: item,
    project_name: item?.project_name
  }));

  // add function
  const handleDialogOpen = () => {
    navigate("/record-mom/add-meeting");
  };
  // edit function
  const employeeEdit = (id, row) => {
    navigate("/record-mom/add-meeting", {
      state: { data: row, type: "edit" },
    });
  };
  // view function
  const employeeView = (id, row) => {
    navigate("/record-mom/add-meeting", {
      state: { data: row, type: "view" },
    });
  };
  const handleDownloadPDF = async (id) => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(
        `${BASE_URL}api/meetingMOMPDFView/${id}/`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `Policy_mom.pdf`;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  // role permission for table
  const actionVisibility = {
    showEdit: CanAccess.can(rolePermission, "Employee Master", "Employee Edit"),
    showView: CanAccess.can(rolePermission, "Employee Master", "Employee View"),
    showDelete: CanAccess.can(
      rolePermission,
      "Employee Master",
      "Employee Delete"
    ),
  };
  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Record MOM
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the Meeting list here.
          </MaterialTypography>
        </Stack>
        {/* <CanAccess module="Employee Master" component="Employee Add"> */}
        <MaterialButton
          variant="gradient"
          color="dark"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleDialogOpen}
        >
          Meeting
        </MaterialButton>
        {/* </CanAccess> */}
      </Stack>

      <SimpleTable
        columns={userColumns}
        data={userData}
        onEdit={employeeEdit}
        deleteAction={false}
        edit={false}
        onView={employeeView}
        isLoading={isLoading}
        download={true}
        onDownload={handleDownloadPDF}
        actionVisibility={actionVisibility}
      />
    </DashboardLayout>
  );
};

export default Meeting;
